import { enumSchema, objectSchema } from "vue-utils"

export interface UnitLength {
	length: number
	unit: LengthUnit
}

export enum LengthUnit {
	Metres = "Metres",
	Feet = "Feet",
}

export const UnitLength = objectSchema<UnitLength>({
	length: Number,
	unit: enumSchema(LengthUnit),
})
